
import Vue from "vue";
import { DataTableCompareFunction, IDataTableColumn } from "../classes/data-table";
import { WinfaktVueComponentsOptions } from "../classes/install-options";
import AppDataTableRow from "./private/DataTableRow.vue";
import { wfVueExtensionsVars } from "../extensions";

interface IWidths {
	[key: number]: string | undefined;
}

export default Vue.extend({
	data() {
		return {
			ordered: null as string | null,
			orderingAscending: false,
			lastClickedItem: null as object | null,
			rootRef: null as null | HTMLElement,
			widths: {} as IWidths,
			thisModalDepth: wfVueExtensionsVars.modalDepth
		};
	},
	props: {
		items: {
			type: Array as ()=>any[],
			default: () => []
		},
		columns: {
			type: Array as () => IDataTableColumn[],
			default: () => []
		},
		selectedItems: {
			type: Array as ()=>any[],
			default: () => []
		},
		orderColumn: {
			type: String,
			default: null
		},
		orderDirection: {
			type: Boolean,
			default: false
		},
		compact: {
			type: Boolean,
			default: false
		},
		compare: {
			type: Function,
		},
		emptyLabel: {
			type: String,
			default():string{
				return WinfaktVueComponentsOptions.defaultDatatableEmptyLabel().toString();
			}
		},
		columnResizeHandle: {
			type: Boolean
		},
		useCheckboxes: Boolean,
		getStyleFunction: {
			type: Function// as (item:any)=>any,
		},
		selectAllLimit: {
			type: Number,
			default(){
				return WinfaktVueComponentsOptions.defaultDataTableSelectAllLimit;
			}
		}
	},
	computed: {
		orderingDirectionText(): string {
			if (!this.orderingAscending) {
				return "sort-amount-up";
			}
			return "sort-amount-down";
		},
		compareFunction(): DataTableCompareFunction {
			if (!this.compare) {
				return WinfaktVueComponentsOptions.defaultDatatableCompare;
			}
			return this.compare as (a: any, b: any) => boolean;
		},
	},
	watch: {
		columns: {
			deep: true,
			immediate: true,
			handler(){
				this.createWidths();
			}
		},
		orderColumn(newVal: string) {
			this.ordered = newVal;
		},
		orderDirection: {
			immediate: true,
			handler(newVal: boolean) {
				this.orderingAscending = newVal;
			}
		},
		items(newVal) {
			if (this.items.indexOf(this.lastClickedItem) == -1) {
				this.lastClickedItem = null;
			}
		}
	},
	methods: {
		createWidths(){
			let val = {} as IWidths;
			this.columns.forEach((el: IDataTableColumn, i: number) => {
				val[i] = "100px";
				if (el.width) {
					val[i] = el.width;
				}
			});
			this.widths = val;
		},
		onContextMenu(event: MouseEvent, item: any = null) {
			this.$emit("contextmenu", {event, item});
		},
		onHeaderContextMenu(event: MouseEvent, column: any = null) {
			//	let propertyName = column.orderColumnName || column.property;
			this.$emit("header-right-click", {column});
		},
		orderClicked(column: IDataTableColumn) {
			if (column.disableSorting) return;
			let propertyName = column.orderColumnName || column.property;
			if (this.ordered == propertyName) {
				this.orderingAscending = !this.orderingAscending;
			} else {
				this.ordered = propertyName;
				this.orderingAscending = false;
			}
			this.$emit("order", {order: propertyName, ascending: this.orderingAscending});
		},
		addItem(item: any) {
			this.saveLastClickedItem(item);
			let i = this.selectedItems.findIndex((a: any) => this.compareFunction(a, item));
			if (i == -1) {
				this.selectedItems.push(item);
			} else {
				this.selectedItems.splice(i, 1);
			}
		},
		addItemIfNoCheckboxes(item:any){
			if (this.useCheckboxes) return;
			this.addItem(item);
		},
		itemClicked(item:any) {
			if (this.selectedItems.length > 0) {
				if (this.selectedItems.length == 1 && this.selectedItems[0] == item){
					this.$emit("item-clicked", item);
					return;
				}
				this.addItem(item);
			} else {
				this.$emit("item-clicked", item);
			}
		},
		selectItem(item: any) {
			this.saveLastClickedItem(item);
			this.removeSelectedItemsFromThisPage();
			this.selectedItems.push(item);
		},
		selectItemIfNoCheckboxes(item:any){
			if (this.useCheckboxes) return;
			this.selectItem(item);
		},
		removeSelectedItemsFromThisPage() {
			for (let i in this.items) {
				let item = this.items[i];
				let found = this.selectedItems.findIndex((a: any) => this.compareFunction(a, item));
				if (found != -1) {
					this.selectedItems.splice(found, 1);
				}
			}
		},
		isClickInCheckboxCol(event:MouseEvent):boolean{
			if (!this.useCheckboxes){
				return false;
			}
			if (!event.target) {
				return false;
			}
			let el = event.target as HTMLElement;
			while (el != this.$el && el != document.body && el != null){
				if (el.classList.contains("checkbox-col")){
					return true;
				}
				el = el.parentElement as HTMLElement;
			}
			return false;
		},
		onItemClick(item:any, event:MouseEvent){
			if (this.isClickInCheckboxCol(event)){
				return;
			}
			this.selectItem(item);
		},
		selectRange(item: any) {
			this.saveLastClickedItem(item);
			this.removeSelectedItemsFromThisPage();
			if (!this.lastClickedItem) {
				this.addItem(item);
			} else {
				let indexOfPrevious = this.items.indexOf(this.lastClickedItem);
				let current = this.items.indexOf(item);
				let smaller = indexOfPrevious < current ? indexOfPrevious : current;
				let larger = indexOfPrevious > current ? indexOfPrevious : current;
				for (let i = smaller; i <= larger; i++) {
					this.selectedItems.push(this.items[i]);
				}
			}
		},
		async saveLastClickedItem(item: any) {
			await Vue.nextTick();
			this.lastClickedItem = item;
		},
		isSelected(item: any): boolean {
			let i = this.selectedItems.findIndex((a: any) => this.compareFunction(a, item));
			if (i == -1)
				return false;
			return true;
		},
		onClick(item: any, column:IDataTableColumn, event:MouseEvent) {
			if (column.click){
				event.stopPropagation();
				event.preventDefault();
				column.click(item);
			}
		},
		onHorizontalScroll(event:Event) {
			this.$emit("scroll-horizontal", event);
		},
		onVerticalScroll(event:Event) {
			this.$emit("scroll", event);
		},
		onColumnResizeStart(column:IDataTableColumn, event:MouseEvent){
			let startX = event.pageX;
			let columnIndex = this.columns.indexOf(column);
			let startWidth = parseInt(this.widths[columnIndex] || "0");

			let onMouseUp = (event:MouseEvent)=>{
				window.removeEventListener("mouseup", onMouseUp);
				window.removeEventListener("mousemove", onMouseMove);
				let width = startWidth + (event.pageX - startX);
				if (width < 50){
					width = 50;
				}
				column.width = `${width}px`;
				this.widths[columnIndex] = column.width;
				this.$emit("new-column-width", columnIndex);
			};

			let onMouseMove = (event:MouseEvent)=>{
				let width = startWidth + (event.pageX - startX);
				if (width < 50){
					width = 50;
				}
				column.width = `${width}px`;
				this.widths[columnIndex] = column.width;
				this.$forceUpdate();
			};

			window.addEventListener("mouseup", onMouseUp);
			window.addEventListener("mousemove", onMouseMove);
		},
		onKeyDown(event:KeyboardEvent){
			if (this.thisModalDepth != wfVueExtensionsVars.modalDepth) return;
			if (event.ctrlKey && event.key.toLowerCase() == "a") {
				if (this.selectedItems.length == this.items.length) {
					this.selectedItems.splice(0, this.selectedItems.length);
				}else{
					this.selectedItems.splice(0, this.selectedItems.length);
					let limit = this.items.length;
					if (this.selectAllLimit) {
						limit = Math.min(limit, this.selectAllLimit);
					}
					this.selectedItems.push(...this.items.slice(0, limit));
				}
				event.preventDefault();
			}
		},
		onHeaderIconClick(column:IDataTableColumn){
			if (!column.headerIconClick) return;
			column.headerIconClick(column);
		}
	},
	mounted() {
		this.ordered = this.orderColumn;
		this.orderingAscending = this.orderDirection;
		this.rootRef = this.$el as HTMLElement;
	},
	created(){
		window.addEventListener("keydown", this.onKeyDown);
	},
	destroyed(){
		window.removeEventListener("keydown", this.onKeyDown);
	},
	components: {
		AppDataTableRow
	}
});
